import React from 'react';
import Banner from '../Banner/Banner';
import Doctors from '../Doctors/Doctors';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <Doctors></Doctors>
        </div>
    );
};

export default Home;